/**
 * Hub de módulos — a tela que aparece depois do login.
 *
 * Mesma regra do sistema atual: nenhum módulo, sem acesso; um só, entra direto
 * (não faz sentido pedir para escolher entre uma opção); vários, escolhe.
 *
 * O motorista tem um só, então nunca vê esta tela — abre já no lugar certo. É
 * de propósito: quem usa em obra, no celular, não deve gastar um toque à toa.
 */

import { MODULOS, modulosDe, type Modulo } from '../modulos.js';
import { escapar } from '../comum/formato.js';
import { VERSAO_ATUAL } from '../versoes.js';
import { abrirHistoricoDeVersoes } from '../comum/historico-versoes.js';

export function montarHub(
  raiz: HTMLElement,
  liberados: string[],
  abrir: (chave: string) => void,
): void {
  const meus = modulosDe(liberados);

  if (meus.length === 0) {
    raiz.innerHTML = `
      <div class="vazio">
        <p>Você está cadastrado, mas ainda não tem nenhum módulo liberado.</p>
        <p style="color:var(--cinza);font-size:.9rem">Peça a um gestor para liberar seu acesso.</p>
      </div>`;
    return;
  }

  if (meus.length === 1 && meus[0]!.pronto) {
    abrir(meus[0]!.chave);
    return;
  }

  raiz.innerHTML = `
    <p class="rotulo" style="margin-bottom:.5rem">Escolha por onde começar</p>
    <div class="modulos">${meus.map(cartao).join('')}</div>
    ${
      meus.length < MODULOS.length
        ? `<p class="nota-rodape">Outros módulos existem no sistema e não estão liberados para você.
             Se precisar de algum, peça a um gestor.</p>`
        : ''
    }
    <p class="nota-rodape hub-versao">
      Sistema CD <b>${escapar(VERSAO_ATUAL.versao)}</b> ·
      <a href="#" data-ver-historico>histórico de atualizações</a>
    </p>`;

  raiz.querySelector('[data-ver-historico]')?.addEventListener('click', (e) => {
    e.preventDefault();
    abrirHistoricoDeVersoes();
  });

  raiz.querySelectorAll<HTMLElement>('[data-modulo]').forEach((el) => {
    el.addEventListener('click', () => {
      const m = MODULOS.find((x) => x.chave === el.dataset['modulo']);
      if (m?.pronto) abrir(m.chave);
    });
  });
}

function cartao(m: Modulo): string {
  return `
    <button class="modulo ${m.pronto ? '' : 'modulo-pendente'}" data-modulo="${m.chave}"
            ${m.pronto ? '' : 'disabled'}>
      <span class="modulo-emoji">${m.emoji}</span>
      <span class="modulo-nome">${escapar(m.nome)}</span>
      <span class="modulo-desc">${escapar(m.descricao)}</span>
      <span class="modulo-onde">${escapar(m.onde)}</span>
      ${
        m.pronto
          ? ''
          : `<span class="modulo-falta"><b>Ainda não migrado.</b> ${escapar(m.falta ?? '')}</span>`
      }
    </button>`;
}
